import seoIndexingPolicy from '../data/seoIndexingPolicy.json';

const getPolicyList = (key) => seoIndexingPolicy?.noindex?.[key] || [];

export const shouldNoindexBlogPost = (blogId) => getPolicyList('blogPosts').includes(blogId);

export const shouldNoindexApplicationDetail = (detailId) =>
  getPolicyList('applicationDetails').includes(detailId);

export const shouldNoindexMediaPost = (mediaId) => getPolicyList('mediaPosts').includes(mediaId);
